import { render, staticRenderFns } from "./DoctorAndMaterials.vue?vue&type=template&id=514e1f1e&scoped=true"
import script from "./DoctorAndMaterials.vue?vue&type=script&lang=js"
export * from "./DoctorAndMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e1f1e",
  null
  
)

export default component.exports